<section class="in-development">
  <h1>{{ tk.General.InDevelopment | t }}</h1>
  <p>{{ tk.General.FeatureNotAvailable | t }}</p>

  <div style="display: flex; gap: 10px; margin-bottom: 12px">
    <a appButton buttonType="outline" [routerLink]="['/dashboard/in-development/select-lab']"
      >Abrir Select Lab</a
    >
    <a
      appButton
      buttonType="outline"
      [routerLink]="['/dashboard/in-development/financial-institution-select-lab']"
      >Abrir Lab de Instituições</a
    >
    <a appButton buttonType="primary" [routerLink]="['/dashboard/in-development/input-lab']"
      >Abrir Input Lab</a
    >
    <a appButton buttonType="outline" [routerLink]="['/dashboard/in-development/calendar-lab']"
      >Abrir Calendar Lab</a
    >
  </div>

  <div style="padding: 20px; max-width: 800px">
    <h2>Teste de Selects Múltiplos</h2>

    <!-- Select com ngModel -->
    <div style="margin-bottom: 30px">
      <h3>Select com ngModel</h3>
      <app-select
        [label]="'Select Múltiplo (ngModel)'"
        [options]="testOptions"
        [multiple]="true"
        [(ngModel)]="selectedOptionsNgModel"
        [placeholder]="'Selecione as opções'">
      </app-select>
      <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px"
        >{{ selectedOptionsNgModel | json }}
      </pre>
    </div>

    <!-- Select com FormGroup -->
    <div style="margin-bottom: 30px">
      <h3>Select com FormGroup</h3>
      <form [formGroup]="testForm">
        <app-select
          [label]="'Select Múltiplo (FormGroup)'"
          [options]="testOptions"
          [multiple]="true"
          [formGroup]="testForm"
          controlName="selectedOptions"
          [placeholder]="'Selecione as opções'">
        </app-select>
      </form>
      <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px"
        >{{ testForm.get('selectedOptions')?.value | json }}
      </pre>
    </div>
  </div>
</section>
